import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { CourierPackageComponent } from './courier-package/courier-package.component';
import { CourierpackageSuccessComponent } from './courier-package/courierpackage-success/courierpackage-success.component';
import { CourierpackageFailureComponent } from './courier-package/courierpackage-failure/courierpackage-failure.component';
import { AuthGuard } from '../core/guards/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full', data: { breadcrumb: 'Home' } },
  { path: 'courierpackage', component: CourierPackageComponent, canActivate: [AuthGuard], data: { breadcrumb: 'EYMP Courier Package' } },
  { path: 'courierpackageEYMPSuccess', component: CourierpackageSuccessComponent, canActivate: [AuthGuard], data: { breadcrumb: 'EYMP Courier Package Success' } },
  { path: 'courierpackageEYMPFailure', component: CourierpackageFailureComponent, canActivate: [AuthGuard], data: { breadcrumb: 'EYMP Courier Package Failure' } },
  { path: 'courierpackageEYMPPendings', component: CourierpackageFailureComponent, canActivate: [AuthGuard], data: { breadcrumb: 'EYMP Courier Package Pending' } },
  { path: 'courierpackageAccessFailure', component: CourierpackageFailureComponent, canActivate: [AuthGuard], data: { breadcrumb: 'EYMP Courier Package Access Failure' } },
  
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EympCourierpackagesRoutingModule { }
